import { atom } from "jotai";

interface IFileUploadAtom {
    uppyInstance: any;
    uppyUploadRequestCount: number;
} 

const INITIAL_FILE_UPLOAD_ATOM_VALUE: IFileUploadAtom = {
    uppyInstance: null,
    uppyUploadRequestCount: 0,
};

export const fileUploadAtom = atom(INITIAL_FILE_UPLOAD_ATOM_VALUE);

export const setUppyInstance = (set: Function, instance) => {
    set((prevState) => {
        let newState: IFileUploadAtom = {
            ...prevState,
        };

        newState.uppyInstance = instance;

        return newState;
    });
}

export const setUppyUploadRequestCount = (set: Function, count: number) => {
    set((prevState) => {
        let newState: IFileUploadAtom = {
            ...prevState,
        };

        newState.uppyUploadRequestCount = count;

        return newState;
    });
};
